import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'
import theme from '@theme/Theme'

import Button from '@components/button/Button'

import useI18n from '@i18n/useI18n'

import { AdminPlanFormScheme, AdminPlanFormFields } from '../scheme'

const GroupedFormLayout = ({ step, form, onNext, onBack, children }: AdminPlanLayoutProps) => {
  const i18n = useI18n()

  const [valid, setValid] = React.useState(false)

  const fields = React.useMemo(() => AdminPlanFormFields[step].map((key) => form[key]), [form, step])

  React.useEffect(() => {
    const schema = AdminPlanFormScheme[step as keyof typeof AdminPlanFormFields]

    if (schema) {
      schema
        .validate(form)
        .then(() => setValid(true))
        .catch(() => setValid(false))
    }
  }, [fields, step])

  return (
    <MainContainer>
      <Title>{i18n.t(`screens.admin.plans.form.${step}.title`, form)}</Title>

      <FixedContainer>{children}</FixedContainer>

      <Buttons>
        <ButtonContainer>
          <Button
            label={i18n.t('screens.incident.previous')}
            status="active"
            onClick={onBack}
            textOnly
            color="light"
            textColor={theme.colors.primaryText}
          />
        </ButtonContainer>
        <ButtonContainer>
          <Button label={i18n.t('common.validate')} status={valid ? 'active' : 'disabled'} onClick={onNext} />
        </ButtonContainer>
      </Buttons>
    </MainContainer>
  )
}

export default GroupedFormLayout

const MainContainer = styled(View)`
  flex: 1;
  flex-direction: column;
`

const FixedContainer = styled(View)`
  flex: 1;
`

const Title = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  margin: 25px 15px;
`

const Buttons = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  background-color: ${(props) => props.theme.colors.background};
`

const ButtonContainer = styled(View)`
  margin: 12px;
`
